import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 1
    }} className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-[#0A0A0A]/90 backdrop-blur-md border-b border-gold/20 py-4' : 'bg-transparent py-6'}`} data-id="element-67">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-68">
          {/* Left Side: Reservar Button */}
          <div className="flex items-center" data-id="element-69">
            <button onClick={() => scrollTo('cta')} className="border border-gold text-gold px-4 py-1.5 hover:bg-gold hover:text-[#0A0A0A] transition-colors font-sans text-[10px] tracking-[0.2em] uppercase" data-id="element-70">
              Reservar
            </button>
          </div>

          {/* Right Side: Navigation Links (Desktop) */}
          <div className="hidden md:flex items-center justify-end gap-8" data-id="element-71">
            <button onClick={() => scrollTo('specialties')} className="text-offwhite/70 hover:text-gold transition-colors font-sans text-xs tracking-[0.2em] uppercase" data-id="element-72">
              Especialidades
            </button>
            <button onClick={() => scrollTo('gallery')} className="text-offwhite/70 hover:text-gold transition-colors font-sans text-xs tracking-[0.2em] uppercase" data-id="element-73">
              Galería
            </button>
            <button onClick={() => scrollTo('about')} className="text-offwhite/70 hover:text-gold transition-colors font-sans text-xs tracking-[0.2em] uppercase" data-id="element-74">
              Sobre Mí
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-75">
            <button onClick={() => setMobileMenuOpen(true)} className="text-gold" data-id="element-76">
              <Menu size={20} strokeWidth={1} data-id="element-77" />
            </button>
          </div>
        </div>
      </motion.nav>

      <AnimatePresence data-id="element-78">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[60] bg-[#0A0A0A] flex flex-col items-center justify-center" data-id="element-79">
            <button onClick={() => setMobileMenuOpen(false)} className="absolute top-6 right-6 text-gold" data-id="element-80">
              <X size={24} strokeWidth={1} data-id="element-81" />
            </button>
            <div className="flex flex-col items-center gap-10" data-id="element-82">
              <button onClick={() => scrollTo('specialties')} className="text-offwhite hover:text-gold transition-colors font-sans text-sm tracking-[0.3em] uppercase" data-id="element-83">
                Especialidades
              </button>
              <button onClick={() => scrollTo('gallery')} className="text-offwhite hover:text-gold transition-colors font-sans text-sm tracking-[0.3em] uppercase" data-id="element-84">
                Galería
              </button>
              <button onClick={() => scrollTo('reviews')} className="text-offwhite hover:text-gold transition-colors font-sans text-sm tracking-[0.3em] uppercase" data-id="element-85">
                Reseñas
              </button>
              <button onClick={() => scrollTo('about')} className="text-offwhite hover:text-gold transition-colors font-sans text-sm tracking-[0.3em] uppercase" data-id="element-86">
                Sobre Mí
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};